export default __webpack_public_path__ + "static/media/smile21.0163b051.jpg";